import { Suspense } from 'react'
import { Nav } from './Nav'
import { Footer } from './Footer'
import { PageTransition } from '@/components/motion/PageTransition'
import { CommandPalette } from '@/components/command/CommandPalette'
import { FootballCursor } from '@/components/motion/FootballCursor'

export function PageShell() {
  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground">
      <Nav />
      <main className="flex-1">
        <Suspense fallback={<div className="container-narrow py-24 text-muted-foreground">Loading…</div>}>
          <PageTransition />
        </Suspense>
      </main>
      <Footer />
      <CommandPalette />
      {/* Football cursor animation — remove this line to disable */}
      <FootballCursor />
    </div>
  )
}
